module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.falseButton) ? _c('div', {
    staticClass: "falsebutton",
    class: _vm.classes,
    on: {
      "click": function($event) {
        return _vm.$emit('falsebutton')
      }
    }
  }, [_c('span', {
    staticClass: "button__text",
    style: (_vm.textStyle)
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)]) : _c(_vm.isButton ? 'ext-link' : 'button', {
    tag: "button",
    staticClass: "button",
    class: _vm.classes,
    style: (_vm.styles),
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.isButton ? false : _vm.type,
      "to": _vm.to
    },
    on: {
      "click": _vm.click
    }
  }, [_c('span', {
    staticClass: "button__text",
    style: (_vm.textStyle)
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a6dcebc","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ext/Button.vue
// module id = ba259c5dd56cea0963e4
// module chunks = 89